<template>
    <p class="text-center disclaimer">
        Al usar este servicio aceptas nuestros<br>
        <a href="/terminos" class="link-footer" >
            términos de uso
        </a>
        y la
        <a href="/privacidad" class="link-footer" >
            política de privacidad
        </a>.
    </p>
</template>
<script>
export default {
  name: 'FooterAuth'
}
</script>
<style scoped>
.link-footer{
    color: black;
    font-weight: bold;
}
</style>
